import { useState } from 'react';
import { Box } from '@mui/material';
import Modal from '../../../components/common/Modal';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useGlobalStore } from 'store/globalStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { Backdrop, CircularProgress } from '@mui/material';
import { CRUD_STATES } from 'constants/app';
import { adminAPI, collectionAPI, seriesAPI } from 'services/admin';
import { useNotification } from 'hooks/useNotification';

export const CustomActionsBoxCollections = ({ data }) => {
  const { id, status, version, title } = data;
  const { setNotify } = useNotification();
  const { setRefreshData, refreshData } = useGlobalStore();
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { showConfirmationButton } = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isCollectionsNewFlow = pathname.includes('/colecoes-novo');
  const collectionWizardPath = isCollectionsNewFlow
    ? '/colecao-novo'
    : '/series';
  const contentResourcePath = isCollectionsNewFlow ? 'collections' : 'series';
  const contentApi = isCollectionsNewFlow ? collectionAPI : seriesAPI;
  const contentLabel = isCollectionsNewFlow ? 'coleção' : 'série';

  const handleEditAndViewVideo = action => {
    setIsLoading(true);
    if (
      action.action === CRUD_STATES.EDIT &&
      (action.status === 'EXPIRED' || action.status === 'PUBLISHED')
    ) {
      const path = `/${action?.id}/versions`;

      contentApi
        .post(path)
        .then(resp => {
          setIsLoading(false);
          navigate(`${collectionWizardPath}/${action?.id}/${resp.version}`, {
            state: {
              action: action.action,
              id: action?.id,
              version: action?.version,
            },
          });
        })
        .catch(error => {
          setIsLoading(false);
          setConfirmDialogAction({ isOpen: false });
          const errorJson = error.request.response;
          const parseJson = JSON.parse(errorJson);
          setNotify({
            isOpen: true,
            message: parseJson.message,
            type: 'error',
            title: 'Ops! Algo deu errado...',
          });
        });
    } else {
      setIsLoading(true);
      navigate(`${collectionWizardPath}/${action?.id}/${action?.version}`, {
        state: {
          action: action.action,
          id: action.id,
          version: action?.version || 1,
        },
      });
    }
  };

  const handleRemoveVideo = async (collectionId, version, title) => {
    setIsLoading(true);
    try {
      const path = `/admin/${contentResourcePath}/${collectionId}/versions/${version}`;

      await adminAPI.del(path);
      setTimeout(() => {
        setConfirmDialogAction({ isOpen: false });
        setNotify({
          isOpen: true,
          message: `A ${contentLabel} "${title}" foi removido com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        setRefreshData(refreshData + 1);
      }, 4000);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setConfirmDialogAction({ isOpen: false });
      const errorJson = error.request.response;
      const parseJson = JSON.parse(errorJson);
      setNotify({
        isOpen: true,
        message: parseJson.message,
        type: 'error',
        title: 'Ops! Algo deu errado...',
      });
      console.log(error);
    }
  };

  const handleArchiveVideo = async (collectionId, version, title) => {
    setIsLoading(true);
    try {
      const path = `/admin/${contentResourcePath}/${collectionId}/versions/${version}/status/archived`;

      await adminAPI.patch(path);
      setTimeout(() => {
        setConfirmDialogAction({ isOpen: false });
        setNotify({
          isOpen: true,
          message: `A ${contentLabel} "${title}" arquivado com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setConfirmDialogAction({ isOpen: false });
        setIsLoading(false);
        setRefreshData(refreshData + 1);
      }, 4000);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setConfirmDialogAction({ isOpen: false });
      const errorJson = error.request.response;
      const parseJson = JSON.parse(errorJson);
      setNotify({
        isOpen: true,
        message: parseJson.message,
        type: 'error',
        title: 'Ops! Algo deu errado...',
      });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Box sx={{ cursor: 'pointer', width: '35px' }}>
        {status === 'DRAFT' ? (
          ''
        ) : status === 'FAILED' ? (
          ''
        ) : (
          <img
            onClick={() => {
              handleEditAndViewVideo({
                action: CRUD_STATES.VIEW,
                id: id,
                version: version,
                status: status,
              });
            }}
            className="eye-icon"
            src="/img/videosDataTable/eye.svg"
            alt="Remover"
            style={{ width: '25px', height: '25px' }}
          />
        )}
      </Box>
      <Box
        onClick={() => {
          handleEditAndViewVideo({
            action: CRUD_STATES.EDIT,
            id: id,
            version: version,
            status: status,
          });
        }}
        sx={{ cursor: 'pointer', width: '35px' }}>
        {status === 'ARCHIVED' ? (
          ''
        ) : status === 'TRANSCODING' ? (
          ''
        ) : (
          <img
            className="archive-icon"
            src="/img/videosDataTable/editpencil.svg"
            alt="Remover"
            style={{ width: '25px', height: '25px' }}
          />
        )}
      </Box>
      <Box sx={{ cursor: 'pointer', width: '35px' }}>
        {status === 'ARCHIVED' ? (
          ''
        ) : status === 'TRANSCODING' ? (
          ''
        ) : status === 'DRAFT' ? (
          <img
            className="trash-icon"
            src="/img/videosDataTable/trash.svg"
            onClick={() =>
              setConfirmDialogAction({
                isOpen: true,
                title: (
                  <div className="modalTitleText">
                    Remover o título "{title}"?
                  </div>
                ),
                subTitle: (
                  <div className="modalBodyText">
                    Você está removendo o título "{title}" permanentemente.
                  </div>
                ),
                children: (
                  <div className="modalRemoveItem">
                    <DeleteOutlineOutlinedIcon color="error" fontSize="12px" />
                  </div>
                ),
                confirmTextButton: 'Remover',
                color: 'error',
                onConfirm: () => {
                  handleRemoveVideo(id, version, title);
                },
                showConfirmationButton: { showConfirmationButton },
                closeTextButton: 'Cancelar',
              })
            }
            alt="Remover"
            style={{ width: '25px', height: '25px' }}
          />
        ) : status === 'FAILED' ? (
          <img
            className="trash-icon"
            src="/img/videosDataTable/trash.svg"
            onClick={() =>
              setConfirmDialogAction({
                isOpen: true,
                title: (
                  <div className="modalTitleText">
                    Remover o título "{title}"?
                  </div>
                ),
                subTitle: (
                  <div className="modalBodyText">
                    Você está removendo o título "{title}" permanentemente.
                  </div>
                ),
                children: (
                  <div className="modalRemoveItem">
                    <DeleteOutlineOutlinedIcon color="error" fontSize="12px" />
                  </div>
                ),
                confirmTextButton: 'Remover',
                color: 'error',
                onConfirm: () => {
                  handleRemoveVideo(id, version, title);
                },
                showConfirmationButton: { showConfirmationButton },
                closeTextButton: 'Cancelar',
              })
            }
            alt="Remover"
            style={{ width: '25px', height: '25px' }}
          />
        ) : (
          <img
            className="archive-icon"
            src="/img/videosDataTable/archive.svg"
            onClick={() =>
              setConfirmDialogAction({
                isOpen: true,
                title: (
                  <div className="modalTitleText">
                    Arquivar o título "{title}"?
                  </div>
                ),
                subTitle: (
                  <div className="modalBodyText">
                    Você irá arquivar o título "{title}" permanentemente.
                  </div>
                ),
                children: (
                  <div className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </div>
                ),
                confirmTextButton: 'Arquivar',
                color: 'primary',
                onConfirm: () => {
                  handleArchiveVideo(id, version, title);
                },
                showConfirmationButton: { showConfirmationButton },
                closeTextButton: 'Cancelar',
              })
            }
            alt="Arquivar"
            style={{ width: '25px', height: '25px' }}
          />
        )}
      </Box>
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
      />
      <Backdrop
        open={isLoading}
        style={{ zIndex: 9999 }}
        sx={{ color: '#fff' }}>
        <CircularProgress color="inherit" size={60} />
      </Backdrop>
    </div>
  );
};


